import { gql } from '@apollo/client';

export const fetchRecentlyCreatedQuotesForHomePageInPPC = gql`
  query fetchRecentlyCreatedQuotesForHomePageInPPC(
    $searchOptions: ConnectionSearchOptions
    $filterOptions: FilterOption
  ) {
    quotes(searchOptions: $searchOptions, filterOptions: $filterOptions) {
      totalCount
      nodes {
        id
        transactionAccountId
        quoteNumber
        status
        createdDate
        shipToObject {
          displayName
        }
        expiryDate
        currency
        total
      }
    }
  }
`;
